import React, { useEffect, useState } from 'react';
import StatCard from '../components/dashboard/StatCard';
import RecentOrders from '../components/dashboard/RecentOrders';
import { callApi } from '../services/ApiServices';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
    const[statData, setStatData] = useState(null)
      const[loading, setLoading] = useState(false)
      const navigate = useNavigate()

  useEffect(() => {
    fetchDashboardStat()
  },[])

    const fetchDashboardStat = async () => {
    try {
      setLoading(true)
      const res = await callApi({
        method: "get",
        url: `admin/dashboard`,
      }); 

      console.log("Dashboard Stat --> ", res)
      setStatData(res?.data)
    } catch (error) {
      console.log("Error fetching dashbaord stat", error)
    }finally{
      setLoading(false)
    }
  }

  return (
    <div className="">
      {/* Stats Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-[17px] mb-3 md:mb-5">
        <StatCard
          title="Clubs/Resorts Onboarded"
          subtitle="Verified venues on the platform"
          value={statData?.total_clubs}
          color="blue"
          loading={loading}
        />
        <StatCard
          title="Total Advertisers"
          subtitle="Registered advertiser accounts"
          value={statData?.total_advisers || 0}
          color="purple"
          loading={loading}
        />
        <StatCard
          title="Total Orders/Transactions"
          subtitle="Completed and active bookings"
          value={statData?.total_transactions || 0}
          color="pink"
          loading={loading}
        />
        <StatCard
          title="Active Campaigns"
          subtitle="Live ads across all resorts"
          value={statData?.active_campaigns || 0}
          color="green"
          loading={loading}
        />
        <StatCard
          title="Total Revenue"
          subtitle="Total earnings generated on the platform"
          value={statData?.total_revenue || 0}
          color="orange"
          loading={loading}
          isCurrency
          RedirectToRevenue={()=> navigate("/revenue-management")}
        />
        <StatCard
          title="Revenue Share To Club"
          subtitle="Total amount allocated to clubs"
          value={statData?.revenue || 0}
          color="yellow"
          loading={loading}
          isCurrency
          RedirectToRevenue={()=> navigate("/revenue-management")}
        />
          <StatCard
          title="Revenue Paid To Club"
          subtitle="Amount already paid to clubs"
          value={statData?.totalPaid || 0}
          color="yellow"
          loading={loading}
          isCurrency
          RedirectToRevenue={()=> navigate("/revenue-management")}
        />
          <StatCard
          title="Pending Revenue"
          subtitle="Amount yet to be paid to clubs"
          value={statData?.totalPending || 0}
          color="red"
          loading={loading}
          isCurrency
          RedirectToRevenue={()=> navigate("/revenue-management")}

        />
      </div>

      {/* Recent Orders */}
      <RecentOrders />
    </div>
  );
};

export default Dashboard;
